export default [{
  'category': 'Gegendstand',
  'name': 'gegenstand',
  'title': 'Gibt es eine Regelung zum Gegenstand des Vertrages?'
}, {
  'category': 'Gegendstand',
  'name': 'dauer',
  'title': 'Sind Beginn und Ende des Auftrages im Vertrag geregelt?'
}, {
  'category': 'Umfang',
  'name': 'hauptvertrag',
  'title': 'Die Inhalte ergeben sich aus dem Leistungsvertrag/Hauptvertrag?'
}, {
  'category': 'Umfang',
  'name': 'weisung',
  'title': 'Gibt es konkrete Weisungen, welche Verarbeitungen vom Auftragnehmer vorzunehmen sind?'
}, {
  'category': 'Umfang',
  'name': 'verwendungszweck',
  'title': 'Ist der Verwendungszweck im Vertrag geregelt?'
}, {
  'category': 'Umfang',
  'name': 'datenarten',
  'title': 'Sind die Datenarten vertraglich festgehalten oder bestimmt bzw. bestimmbar?'
}, {
  'category': 'Umfang',
  'name': 'personkreis',
  'title': 'Ist der Kreis der betroffenen Personen dem Vertrag zu entnehmen?'
}, {
  'category': 'Standort',
  'name': 'ort',
  'title': 'Ist der geografische Ort (Land) der Auftragsverarbeitung definiert?'
}, {
  'category': 'Verantwortlichenrechten',
  'name': 'weisungsrecht',
  'title': 'Ist das Weisungsrecht (insbesondere das Recht zu ergänzenden Weisungen) im Vertrag geregelt?'
}, {
  'category': 'Verantwortlichenrechten',
  'name': 'kontrollrechten',
  'title': 'Gibt es Regelungen zu Kontrollrechten des Auftraggebers und entsprechenden Duldungspflichten des Auftragnehmers?'
}, {
  'category': 'Verantwortlichenrechten',
  'name': 'melden',
  'title': 'Gibt es eine Regelung, aus der sich die Pflicht des Auftragnehmers ergibt, Verstöße gegen Datenschutzvorschriften (insbesondere der DSGVO) oder gegen die vom Auftraggeber erteilten Weisungen zu melden?'
}, {
  'category': 'Verantwortlichenrechten',
  'name': 'meldfrist',
  'title': 'Ist im Vertrag eine Frist geregelt, binnen derer der Auftragnehmer nach Kenntnis eines Datenschutzvorfalls eine Meldung gegenüber dem Auftraggeber zu machen hat?'
}, {
  'category': 'Auftragsverarbeiterpflichten',
  'name': 'bestellungspflicht',
  'title': 'Ist für den Auftragnehmer ein Datenschutzbeauftragter angegeben oder ist der Auftragnehmer nicht bestellungspflichtig?'
}, {
  'category': 'Auftragsverarbeiterpflichten',
  'name': 'vertraulichkeit',
  'title': 'Gibt es eine Regelung zur Verpflichtung der Beschäftigten des Auftragnehmers zur Vertraulichkeit?'
}, {
  'category': 'Auftragsverarbeiterpflichten',
  'name': 'betroffenenauskunft',
  'title': 'Ist im Vertrag die Zusammenarbeit bzw. Unterstützung des Auftraggebers durch den Auftragnehmer bei Geltendmachung der Rechte der betroffenen Personen geregelt? (Der Auftragnehmer unterstützt den Auftraggeber bei der Ausführung von Betroffenenrechten und leitet Geltendmachungen an den Verantwortlichen weiter)'
}, {
  'category': 'Auftragsverarbeiterpflichten',
  'name': 'loeschen',
  'title': 'Gibt es eine Regelung, aus der sich die Pflicht des Auftragnehmers ergibt, überlassene Datenträger zurückzugeben bzw. für den Auftraggeber gespeicherte Daten zu löschen?'
}, {
  'category': 'Unterauftragsverhältnisse',
  'name': 'zulaessigkeit',
  'title': 'Gibt es eine Regelung zur Zulässigkeit von Unterauftragsverhältnissen („Ob“)?'
}, {
  'category': 'Unterauftragsverhältnisse',
  'name': 'wie',
  'title': 'Gibt es eine Regelung dazu, wie der Unterauftragnehmer zu beauftragen ist („Wie“)?'
}, {
  'category': 'Unterauftragsverhältnisse',
  'name': 'genehmigung',
  'title': 'Gibt es eine Regelung dazu, wie neue Unterauftragnehmer vom Auftraggeber zu genehmigen sind bzw. im Falle einer allgemeinen Genehmigung, dass neue Unterauftragnehmer dem Auftraggeber im Voraus benannt werden und dem Auftraggeber ein Widerspruchsrecht zusteht.'
}, {
  'category': 'Unterauftragsverhältnisse',
  'name': 'kontrollerechtenunterauftragnehmer',
  'title': 'Gibt es eine Regelung zu Kontrollrechten des Auftraggebers gegenüber etwaigen Unterauftragnehmern? (z. B. Kontrolle vor Ort, Herausgabe von Informationen etc.)'
}, {
  'category': 'TOMs',
  'name': 'tomsvertraulichkeit',
  'title': 'Gibt es Regelungen zur Gewährleistung der Vertraulichkeit?'
}, {
  'category': 'TOMs',
  'name': 'integritaet',
  'title': 'Gibt es Regelungen zur Gewährleistung der Integrität?'
}, {
  'category': 'TOMs',
  'name': 'belastbarkeit',
  'title': 'Gibt es Regelungen zur Gewährleistung der Belastbarkeit der Systeme auf Dauer?'
}, {
  'category': 'TOMs',
  'name': 'verfuegbarkeit',
  'title': 'Gibt es Regelungen zur Gewährleistung der Verfügbarkeit?'
}, {
  'category': 'TOMs',
  'name': 'wiederherstellung',
  'title': 'Gibt es Regelungen zur Fähigkeit des Auftragsverarbeiters, die Verfügbarkeit der personenbezogenen Daten und den Zugang zu ihnen bei einem physischen oder technischen Zwischenfall rasch wiederherzustellen?'
}, {
  'category': 'TOMs',
  'name': 'tomskontrolle',
  'title': 'Gibt es Regelungen dazu, wie der Auftragsverarbeiter die regelmäßige Überprüfung, Bewertung und Evaluierung der Wirksamkeit der technischen und organisatorischen Maßnahmen zur Gewährleistung der Sicherheit der Verarbeitung gewährleistet?'
}]

